import { Store } from "redux";
import { addNotification } from "@/redux/slices/notifications";
import { v4 } from "uuid";

export const apiMiddleware =
  (store: Store) =>
  (next: any) =>
  async (action: {
    meta: Record<any, any>;
    payload?: any;
    type: string;
    error?: any;
  }) => {
    const { getState, dispatch } = store;

    const notificationId = v4();
    if (action.error && action.payload) {
      dispatch(
        addNotification({
          id: notificationId,
          message: action.payload || action.error?.message,
          color: "error",
        })
      );
    }

    if (action.payload?.notify) {
      dispatch(
        addNotification({
          id: notificationId,
          title: action.payload.notify.title,
          message: action.payload.notify.message || action.payload.notify,
          color: "secondary",
        })
      );
    }

    next(action);
  };
